<template>
  <div id="directions-address-search-box">

  	<div id="directions-address-search-back-box" class="white-box d-none d-sm-block">
		<div id="directions-address-search-back-btn" class="text-center" @click="goBackFromAddressSearch" tabindex="0">
  			<span class="material-icons" aria-hidden="true">chevron_left</span>
  			<span>Tilbage</span>
  		</div>
  		<div id="directions-address-search-back-text">
  			Søg efter destination
  		</div>
  	</div>

  	<div id="address-search-input-box" class="white-box">
  		<input id="address-search-input" type="text" aria-label="Søg efter sted, vej eller adresse" placeholder="Søg efter sted, vej eller adresse..." autocomplete="off" autofocus="true" @keyup="searchForDestination($event)">
  	</div>

  	<div class="white-box">
  		<div id="address-search-gps" @click="useGpsForAddress();" tabindex="0">
  			<span class="material-icons" aria-hidden="true">gps_fixed</span>
  			Brug min position
  		</div>
  		<div class="list-category" @click="showUserSearchHistory();"  tabindex="0">
  			<span class="material-icons" aria-hidden="true">history</span>
  			Vælg fra min historik
  		</div>
  	</div>

  	<div id="address-search-output-box" class="white-box">
  		<ul id="address-search-output">
        <li class="clear-history-li" @click="clearHistory" v-show="showUserHistory" tabindex="0">
          Slet adresse historik
        </li>
        <template v-for="(item,index) in searchResult">
          <DirectionsSearchResultItem :item="item" :tagList="SmartSearch.tagList" @addressSelected="getDestinationData"></DirectionsSearchResultItem>
        </template>
        <li class="search-no-result" v-show="noSearchResults">
  					<!--Vi kunne ikke finde {{ addressInput }}. Hvis ingen af de 3 tip nedenfor hjælper kan du foreslå {{ addressInput }} som sted i Odense Rundt - <router-link :to="{path: '/contact/tip'}" class="blue-text"> klik her.</router-link><br><br>-->
  					Vi kunne ikke finde {{ addressInput }}. Hvis ingen af de 3 tip nedenfor hjælper kan du foreslå {{ addressInput }} som sted i Odense Rundt ved at sende os en mail på <a href="mailto:odenserundt@odense.dk" class="underline">OdenseRundt@odense.dk</a><br><br>
  					Tip 1: Tjek om din søgning er stavet korrekt.<br>
  					Tip 2: Prøv at lave mellemrum foran "vej" eller "gade" i vejnavne. Veje med personnavne er ofte opdelt i flere led. Det hedder for eksempel Jens Juels Vej.<br>
  					Tip 3: Prøv at skrive de første bogstaver af navnet og se, om der dukker søgeforslag op i listen under søgefeltet.<br><br>
				</li>
  		</ul>
  	</div>
  </div>
</template>

<script>
import axios from 'axios'
import DirectionsSearchResultItem from '@/components/directions/DirectionsSearchResultItem.vue'
import SmartSearch from '@/assets/SmartSearch.js'
import DataManager from '@/assets/DataManager.js'
import TGPS from '@/assets/TinyGps.js'
import { EventBus } from '@/main.js'
import Profile from '@/assets/profile/Profile.js'

export default {
  data() {
    return {
      searchResult: {},
      noSearchResults: false,
      addressInput: '',
      showUserHistory: false,
      timeout: false,
    }
  },
  props: {
    direction: {
      required: true,
    }
  },
  components: {
    DirectionsSearchResultItem
  },
  created() {
    this.SmartSearch = SmartSearch;
  },
  methods: {
    goBackFromAddressSearch() {
      this.$router.back();
    },
    searchForDestination(event) {
      this.showUserHistory = false;
      this.noSearchResults = false;
      var input = document.getElementById('address-search-input');
      clearTimeout(this.timeout);
      if(input.value.length > 2) {
        this.timeout = setTimeout(() => {
          this.addressInput = input.value;
          this.searchResult = {};
          SmartSearch.searchAddresses(input, data => {
              //console.log(data);
              //Saved user addresses
              if(Profile.loggedIn) {
                for(var i in Profile.userData.likes) {
                  if(Profile.userData.likes[i] == undefined){
                    continue;
                  }
                  if(Profile.userData.likes[i].type == 'address') {
                    var like = JSON.parse(Profile.userData.likes[i].value);
                    if(like.name.toLowerCase().indexOf(input.value) != -1 || like.alias && like.alias.toLowerCase().indexOf(input.value) != -1) {
                      var name = like.alias || like.name;
                      data.unshift({name: name, type: 'userAddress', coords: {lat: like.coords.lat, lng: like.coords.lng}});
                    }
                  }
                }
              }
              this.searchResult = data;
              if(data.length == 0) {
                this.noSearchResults = true;
              }
            },
            function() {
              console.log('Clear');
            }
          );
        }, 1500);
      }
    },
    showUserSearchHistory() {
      this.noSearchResults = false;
      this.searchResult = {};
      this.showUserHistory = true;
      setTimeout(() => {
        var history = localStorage.getItem('OdenseRundt-DestinationHistory');
        if(history == null) {
          //return result;
          this.noSearchResults = true;
        }
        else {
          history = JSON.parse(history).reverse();
          var result = [];
          for(var i = 0; i < 100; i++) {
            if(history[i] == undefined || history[i].name == '') {
              continue;
            }
            result.push(history[i]);
          }
          this.searchResult = result;
        }
      }, 500);
    },
    clearHistory() {
      this.showUserHistory = false;
      this.searchResult = {};
      localStorage.removeItem('OdenseRundt-DestinationHistory');
    },
    useGpsForAddress() {
      var that = this;
      if(!TGPS.watchID) {
        TGPS.set({
          onSuccess: function() {that.useGpsCoordsForAddress()},
          onError: function(e){
            that.GPSError(e);
            TGPS.clearWatch();
          }
        });
        TGPS.watch();
      }
      else {
        TGPS.takeOver(function() {that.useGpsCoordsForAddress()});
      }
    },
  	useGpsCoordsForAddress: function() {
  		var coords = TGPS.get();
  		//console.log(coords);
  		//console.log(TGPS.acc);
  		var acc = this.$DeviceCheck.isIOS ? 15 : 45;
  		/*$('#directions-address-search-box').addClass('hidden');
  		this.directionsGps.showGpsCircle();*/
  		if(TGPS.acc <= acc || !this.$DeviceCheck.isMobile) {
  			var options = {direction: this.direction, type: 'coords', coords: {lat: coords.lat, lng: coords.lng}};
  			this.getDestinationData(options);
  			//this.directionsGps.removeGpsCircle();
  			//this.hideGPSQuestions();
        TGPS.clearWatch();
  		}
  	},
    getDestinationData(item) {
      console.log(item);
      this.searchResult = {};
      //console.log(item);
  		var options = {
        direction: item.direction ? item.direction : this.direction,
        name: item.name,
        type: item.type,
        tagId: item.tagId,
        placeId: item.placeId,
        coords: {lat: item.coords ? item.coords.lat : false, lng: item.coords ? item.coords.lng : false},
        href: item.href
      };

      if(options.type == 'coords' || options.type == 'userAddress') {
        if(options.name == undefined) {
          axios.get('https://dawa.aws.dk/adgangsadresser/reverse?x='+options.coords.lng+'&y='+options.coords.lat)
          .then(response => {
            //console.log(response);
            options.name = response.data.vejstykke.navn+' '+response.data.husnr;
          })
          .catch(function(error) {
            console.log(error);
          })
          .then(() => {
            this.$emit('addressDataReady', options, options.name);
          });
        }
        else {
          this.$emit('addressDataReady', options, options.name);
        }
      }
  		//Place type - Check for accessPoint else gets coords of place
      if(options.tagId != undefined && options.tagId != 'undefined') {
        DataManager.getData([
          DataManager.newTags+options.tagId+'-dk-light.json',
        ], (response) => {
          var item;
    			for(var i in response[0].data.features) {
    				if(response[0].data.features[i].id == options.placeId) {
    					item = response[0].data.features[i];
    					//Stop search if geometry is a point - Keep searching if item is polygon for best coord placement.
    					if(item.geometry.type == 'Point') {
    						break;
    					}
    				}
    			}
    			//Check for access point
    			if(item.geometry.accesspoints) {
    				var accessPointCar = false;
    				var accessPointBike = false;
    				var accessPointPedestrian = false;

    				for(var i in item.geometry.accesspoints) {
    					if(item.geometry.accesspoints[i].pointtype == 'access_car') {
    						accessPointCar = {lat: item.geometry.accesspoints[i].coordinates[1], lng: item.geometry.accesspoints[i].coordinates[0]}
    					}
    					if(item.geometry.accesspoints[i].pointtype == 'access_bike') {
    						accessPointBike = {lat: item.geometry.accesspoints[i].coordinates[1], lng: item.geometry.accesspoints[i].coordinates[0]}
    					}
    					if(item.geometry.accesspoints[i].pointtype == 'access_walk') {
    						accessPointPedestrian = {lat: item.geometry.accesspoints[i].coordinates[1], lng: item.geometry.accesspoints[i].coordinates[0]}
    					}
    				}
    				options.accessPoints = {
    					car: accessPointCar,
    					bike: accessPointBike,
    					pedestrian: accessPointPedestrian
    				};
    			}
    			if(item.geometry.type == 'Point') {
    				options.coords.lat = item.geometry.coordinates[1];
    				options.coords.lng = item.geometry.coordinates[0];
    			}
    			else if(item.geometry.type == 'LineString') {
    				options.coords.lat = item.geometry.coordinates[0][1];
    				options.coords.lng = item.geometry.coordinates[0][0];
    			}
    			else if(item.geometry.type == 'Polygon') {
    				options.coords.lat = item.geometry.coordinates[0][0][1];
    				options.coords.lng = item.geometry.coordinates[0][0][0];
    			}
          this.$emit('addressDataReady', options, options.name+' ('+options.type+')');
        });
      }
  		//Addresse eller vej
  		if(options.type == 'Adresse' || options.type == 'Vej') {
  			if(options.coords.lat == false || options.coords.lat == undefined) {
  				var url = encodeURI(options.href);
          axios.get(url)
          .then(response => {
            //console.log(response);
  					if(options.type == "Vej") {
  						response.data.sort(function(a, b) {
  							var re = /\D/g;
  							return (parseInt(a.husnr.replace(re, ""), 10) - parseInt(b.husnr.replace(re, ""), 10));
  						});
  						options.coords.lat = response.data[0].adgangspunkt.koordinater[1];
  						options.coords.lng = response.data[0].adgangspunkt.koordinater[0];
  					}
  					else {
  						options.coords.lat = response.data.adgangspunkt.koordinater[1];
  						options.coords.lng = response.data.adgangspunkt.koordinater[0];
  					}
  					//Set address and data in routeplanner class
  					this.$emit('addressDataReady', options, options.name);
          })
          .catch(function (error) {
            console.log(error);
          });
  			}
  			else {
  				this.$emit('addressDataReady', options, options.name);
  			}
  		}
  	},
    gpsError(errorCode) {
    	switch(errorCode.code) {
    		//User denied
    		case 1:
          EventBus.$emit('openMessageBox', {message: 'GPS brug afvist af brugeren', btnText: 'Ok'});
    			break;
    		//Location unavailable
    		case 2:
    			EventBus.$emit('openMessageBox', {message: 'GPS lokation ikke tilgængelig.', btnText: 'Ok'});
    			break;
    		//Location timeout
    		case 3:
    			EventBus.$emit('openMessageBox', {message: 'GPS lokation kunne ikke tilgås.', btnText: 'Ok'});
    			break;
    	}
    },
  },
}
</script>

<style lang="scss" scoped>
  #directions-address-search-box {
    position: absolute;
    top: 0px;
    z-index: 1000;
    height: 100%;
    width: 100%;
    padding: 10px 5px;
    background-color: #f1f1f1;
  }

  @media screen and (min-width: 768px) {
    #directions-address-search-box {
      top: 55px;
    }
  }

  @media screen and (min-width: 996px) {
    #directions-address-search-box {
      left: 10px;
      width: 500px;
      height: auto;
      max-height: 400px;
    }
  }

  @media screen and (min-width: 1199px) {
    #directions-address-search-box {
      top: 60px;
    }
  }

  /*Address back btn for desktop*/
  #directions-address-search-back-box {
    position: relative;
    height: 50px;
    width: 100%;
    margin-bottom: 10px;
  }

  #directions-address-search-back-btn {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 45px;
    cursor: pointer;
  }

  #directions-address-search-back-btn span {
    position: relative;
    top: 30px;
    font-size: 12px;
  }

  #directions-address-search-back-btn .material-icons {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 25px !important;
  }

  #directions-address-search-back-text {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
  }

  /*Address search input*/
  #address-search-input-box {
    height: 40px;
    padding: 5px;
    margin-bottom: 10px;
  }

  #address-search-input-icon {
    position: relative;
    top: 5px;
    left: 0px;
  }

  #address-search-input {
    height: 30px;
    width: 100%;
    padding-left: 5px;
    border: 2px solid #d1d1d1;
    color: #565656;
  }
  /*List categories select*/
  #address-search-gps {
  	border-bottom: 1px solid #eee;
  }

  .list-category, #address-search-gps {
  	position: relative;
  	height: 40px;
  	margin-bottom: 0px;
  	padding: 5px 5px 5px 45px;
  	line-height: 30px;
  	vertical-align: middle;
  	border-top: 1px solid #eee;
    cursor: pointer;
  }

  .list-category .material-icons, #address-search-gps .material-icons {
  	position: absolute;
  	left: 10px;
  	top: 6px;
  	font-size: 25px !important;
  }

  /*Address search output*/
  #address-search-output-box {
  	position: relative;
  	z-index: 1000;
  	height: auto;
  	max-height: calc(100% - 100px);
  	overflow-y: auto;
  }

  @media screen and (min-width: 992px) and (orientation: landscape) {
  	#address-search-output-box {
  		max-height: 300px;
  	}
  }

  #address-search-output {
  	margin: 0;
  }

  #address-search-output li {
  	padding: 0px 5px;
  	border-top: 1px solid #dedede;
  	cursor: pointer;
  }

  .clear-history-li {
    height: 43px;
    line-height: 43px;
    vertical-align: middle;
    font-weight: 600;
  }
</style>
